/**
 * Verify that the data object contains all the keys
 * @param data - The data object to verify
 * @param keys - The keys to verify
 * @returns A boolean indicating if the data object contains all the keys
 */
var verifyDataExists = function verifyDataExists(data, keys) {
  var result = true;

  for (var i = 0; i < keys.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(data, keys[i])) {
      if (false || false) {
        console.log("\nMissing required \"".concat(String(keys[i]), "\" property"));
      }

      result = false;
    }
  }

  return result;
};

export default verifyDataExists;